module.exports = __webpack_public_path__ + "static/media/orangePerkTick.670b6813.svg";